module.exports = __webpack_public_path__ + "img/about_03.9ae89d73.jpg";